/*
 * A lifted card: white, the dialog chrome's `gray-300` hairline and `xl` radius, and the action
 * card's resting shadow, because it floats over the page rather than sitting in it
 * (design/50-components.md "Card": a shadow means lifted). React Aria's default offset puts it
 * `sm` (8px) from its trigger, the arrow included. Never wider than the window allows.
 */
.callout {
  box-sizing: border-box;
  inline-size: 20rem;
  max-inline-size: calc(100vw - 2 * var(--space__lg));
  border: 1px solid var(--color__gray-300);
  border-radius: var(--border-radius__xl);
  background: var(--color__white);
  box-shadow: 0 1px 2px oklch(from var(--color__gray-900) l c h / 0.15);
  outline: none;
}

/*
 * The text column stops short of the ×, which sits in the corner as the modal's close control
 * does, so a title that wraps never runs under it.
 */
.body {
  position: relative;
  padding: var(--space__lg);
  padding-inline-end: var(--space__3xl);
}

.dismiss {
  position: absolute;
  inset-block-start: var(--space__sm);
  inset-inline-end: var(--space__sm);
}

/* The action sits at the start of the text column, on its own line. */
.action {
  display: flex;
}

/* The popover's arrow, in the card's own fill and hairline. */
.arrow > svg {
  display: block;
  fill: var(--color__white);
  stroke: var(--color__gray-300);
  stroke-width: 1px;
}

.arrow[data-placement='bottom'] > svg {
  transform: rotate(180deg);
}
